// extracted by mini-css-extract-plugin
export default {"select-cities":"jUnZ5XdP2qBahdDoyXrI"};